import React from "react";
import { observable, computed, toJS } from 'mobx';
import { observer, inject } from "mobx-react";


@inject("store")
@observer
export default class ChooseCustomer extends React.Component {

	constructor(props) {
		super(props);

	}



	render() {


		return (<div>
			<h6 className="text-muted text-normal text-uppercase">Select customer</h6>
			

			<div className="text-sm">
				<table className="table table-hover ">
					<thead>
						<tr>
							<th>Customer name</th>
							<th>Number</th>

						</tr>
					</thead>
					<tbody>

						{this.props.store.account.Customers.map(customer => (
							<tr style={{cursor:"pointer"}} key={customer.Id} onClick={(e) => {
								
								this.props.store.navigation.setLocationCustomerId(customer.Id);
								this.props.store.navigation.closeToolbar();
							}}>
								<td><strong>{customer.Name}</strong></td>
								<td>{customer.Number}</td>
								
							</tr>))}

					</tbody>

				</table>
			</div>
		</div>);

	}
}